import { createContext, useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import jwtDecode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import AccountService from "src/services/AccountService";
import EmployeeService from "../services/EmployeeService";
import { toast } from "react-toastify";

const AuthContext = createContext();

// eslint-disable-next-line react/prop-types
export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    if (localStorage.getItem("tokens")) {
      let tokens = JSON.parse(localStorage.getItem("tokens"));
      return jwt_decode(tokens.token);
    }
    return null;
  });
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);
  const [tokenExpired, setTokenExpired] = useState(false);

  const navigate = useNavigate();

  const hasToken = () => {
    return !!localStorage.getItem("tokens");
  };

  useEffect(() => {
    // Check if the user is authenticated and has a JWT token stored
    // console.log(isAuthenticated);
    if (checkIsAuthenticated()) {
      setUserInfoData();
    }
  }, [isAuthenticated]);

  // Check if the token is expired
  const isTokenExpired = () => {
    // Implement your logic to check token expiration here
    // For example, compare the expiration timestamp with the current time
    let tokensData = JSON.parse(localStorage.getItem("tokens"));
    if (tokensData === null) {
      return false;
    }
    const { exp } = jwtDecode(tokensData?.refreshToken);
    const currentTime = Date.now() / 1000;
    return exp && exp < currentTime;
  };

  // Check if the token is expired
  const checkIsAuthenticated = () => {
    return hasToken() && !isTokenExpired();
  };

  const setUserInfoData = async () => {
    return await EmployeeService.getMe()
      .then((response) => {
        setUserData(response.data);
        return response.data;
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const login = async (payload) => {
    const apiResponse = await AccountService.login(payload)
      .then((response) => {
        localStorage.setItem("tokens", JSON.stringify(response.data));
        setUser(jwt_decode(response.data.token));
        setIsAuthenticated(true);
        setUserInfoData().then((usrData) => {
          if (usrData.role === "USER") {
            navigate("/my-locations");
          }
        });
      })
      .catch((err) => {
        toast.error(err.response?.data.message);
      });
    navigate("/");
  };

  const logout = async () => {
    setUser(null);
    setUserData(null);
    localStorage.clear();
    navigate("/");
  };
  return (
    // eslint-disable-next-line react/react-in-jsx-scope
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        userData,
        isAuthenticated,
        isTokenExpired,
        checkIsAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
